// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1331) return "static/css/1331.51123f4a368cde0bb58d.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + "83971b4df2c901ec0bdb" + ".chunk.css";
};